import { type ReactNode, useState } from "react";

import { trpc } from "@blis/trpc/react";

import { ConfirmPrompt } from "@/components/ConfirmPrompt";
import { mutationResponse } from "@/utils/trpc";

export function RemoveEmailNotificationDialog({
  org,
  email,
  children,
}: {
  children: ReactNode;
  org: { id: number };
  email: string;
}) {
  const [open, setOpen] = useState(false);
  const deleteNotification =
    trpc.admin.org.deleteEmailNotification.useMutation();

  const confirm = () => {
    deleteNotification.mutate(
      {
        email,
        orgId: org.id,
      },
      mutationResponse({
        errorTitle: "Error removing email notification",
        successMessage: "Email notification removed",
        onSuccess() {
          setOpen(false);
        },
      }),
    );
  };

  return (
    <ConfirmPrompt
      open={open}
      onOpenChange={setOpen}
      onConfirm={confirm}
      title="Remove notification"
      message="Are you sure you want to remove this notification?"
      loading={deleteNotification.isPending}
      danger
    >
      {children}
    </ConfirmPrompt>
  );
}
